module.exports = __webpack_public_path__ + "static/img/102411.2b6213ec.png";